<template lang="pug">
	div
		div.mt-2(v-if="resultados && resultados.clientes.length > 0")
			div.card
				div.card-header
					| Resultados
					download-excel(
						class   = "btn btn-warning btn-sm"
						:data   = "json_data"
						:fields = "json_fields"
						:meta   = "json_meta"
						name	= "informe.xls"
					)
						span.fa.fa-download.mr-2
						| XLS
				div.table-responsive
					table.table.table-striped.table-condensed.text-right
						thead
							tr.bg-dark.text-white
								th(@click="ordenar('nombre', 'nombre')")
									| Cliente
									span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'nombre'")
								th(v-for="campo in resultados.campos" :key="campo.campo" @click="ordenar('campo', campo.campo)")
									| {{campo.nombre}}
									span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'campo' && orden.campo === campo.campo")
								template(v-if="resultados.clientes[0].soportes && resultados.clientes[0].soportes.length > 0")
									th(v-for="(soporte, i) in resultados.clientes[0].soportes" :key="soporte.ID_soporte" @click="ordenar('soporte', i)")
										| {{soporte.nombre}}
										span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'soporte' && orden.campo === i")
								template(v-if="resultados.clientes[0].eventos")
									th(@click="ordenar('eventos', 'eventos')") Eventos
									span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'eventos'")
								template(v-if="resultados.clientes[0].partidas && resultados.clientes[0].partidas.length > 0")
									th(v-for="(partida, i) in resultados.clientes[0].partidas" :key="partida.ID" @click="ordenar('partida', i)")
										| {{partida.nombre}}
										span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'partida' && orden.campo === i")
						tbody
							tr(v-for="cliente in resultadosClientes" :key="cliente.ID_cliente")
								td
									| {{cliente.nombre}}
								td.importe(v-for="(campo, id) in cliente.campos" :key="campo.campo" @click="verDetalles(cliente.nombre, campo.meses, campo.nombre)")
									| {{campo.importe | currency('')}}
									span(v-if="id === 'cobertura'") %
									span(v-if="id !== 'cobertura'") €
								template(v-if="cliente.soportes && cliente.soportes.length > 0")
									td.importe(v-for="soporte in cliente.soportes" :key="soporte.ID_soporte" @click="verDetallesSoporte(cliente.nombre, soporte.meses, 'Soporte: ' + soporte.nombre)") {{soporte.total.real | currency('')}} €
								template(v-if="cliente.eventos")
									td.importe(@click="verDetalles(cliente.nombre, cliente.eventos.meses, 'Eventos')")
										| {{cliente.eventos.importe | currency('')}} €
								template(v-if="cliente.partidas && cliente.partidas.length > 0")
									td.importe(v-for="partida in cliente.partidas" :key="partida.ID" @click="verDetalles(cliente.nombre, partida.meses, 'Partida: ' + partida.nombre)")
										| {{partida.importe | currency('')}} €
		detalles-meses(
			v-if="detalles"
			:meses="detalles.meses"
			:cliente="detalles.cliente"
			:tipo="detalles.tipo"
			@cerrar="detalles = null"
		)
</template>

<script>
import DetallesMeses from './verDetalles'
export default {
	props: ['resultados'],
	components: {
		DetallesMeses
	},
	data () {
		return {
			detalles: null,
			orden: {
				tipo: 'nombre',
				campo: 'nombre',
				sentido: 1
			}
		}
	},
	computed: {
		resultadosClientes () {
			if (!this.resultados) {
				return []
			}
			if (this.orden.campo) {
				return [].concat(this.resultados.clientes).sort((a, b) => {
					if (this.orden.tipo === 'campo') {
						if (a.campos[this.orden.campo].importe > b.campos[this.orden.campo].importe) {
							return this.orden.sentido
						} else if (a.campos[this.orden.campo].importe < b.campos[this.orden.campo].importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'soporte') {
						if (a.soportes[this.orden.campo].total.real > b.soportes[this.orden.campo].total.real) {
							return this.orden.sentido
						} else if (a.soportes[this.orden.campo].total.real < b.soportes[this.orden.campo].total.real) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'eventos') {
						if (a.eventos.importe > b.eventos.importe) {
							return this.orden.sentido
						} else if (a.eventos.importe < b.eventos.importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'nombre') {
						if (a.nombre > b.nombre) {
							return this.orden.sentido
						} else if (a.nombre < b.nombre) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'partida') {
						if (a.partidas[this.orden.campo].importe > b.partidas[this.orden.campo].importe) {
							return this.orden.sentido
						} else if (a.partidas[this.orden.campo].importe < b.partidas[this.orden.campo].importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					}
				})
			} else {
				return this.resultados.clientes
			}
		},
		json_data () {
			if (!this.resultados) {
				return []
			}

			const arr = []

			for (let i = 0; i < this.resultados.clientes.length; i++) {
				const cliente = this.resultados.clientes[i]
				const obj = {}
				obj.cliente = cliente.nombre

				for (let k in cliente.campos) {
					obj[k] = cliente.campos[k].importe.toString().replace('.', ',')
				}

				for (let k in cliente.soportes) {
					obj[cliente.soportes[k].nombre] = cliente.soportes[k].total.real.toString().replace('.', ',')
				}

				if (cliente.eventos) {
					obj['eventos'] = cliente.eventos.importe.toString().replace('.', ',')
				}

				for (let k in cliente.partidas) {
					obj[cliente.partidas[k].nombre] = cliente.partidas[k].importe.toString().replace('.', ',')
				}

				arr.push(obj)
			}

			return arr
		},
		json_fields () {
			if (!this.resultados) {
				return {}
			}
			const f = {}

			f.cliente = 'Number'
			for (let k in this.resultados.clientes[0].campos) {
				f[k] = 'Number'
			}

			for (let k in this.resultados.clientes[0].soportes) {
				const nombre = this.resultados.clientes[0].soportes[k].nombre
				f[nombre] = 'Number'
			}

			if (this.resultados.clientes[0].eventos) {
				f['eventos'] = 'Number'
			}

			for (let k in this.resultados.clientes[0].partidas) {
				const nombre = this.resultados.clientes[0].partidas[k].nombre
				f[nombre] = 'Number'
			}
			return f
		},
		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		}
	},
	methods: {
		ordenar (tipo, campo) {
			this.orden.tipo = tipo
			if (this.orden.campo === campo) {
				this.orden.sentido = this.orden.sentido * -1
			} else {
				this.orden.campo = campo
				this.orden.sentido = 1
			}
		},
		verDetalles (cliente, meses, tipo) {
			this.detalles = {
				cliente: cliente,
				meses: meses,
				tipo: tipo,
				fechas: this.resultados.fechas
			}
		},

		verDetallesSoporte (cliente, meses, tipo) {
			const m = {}

			for (let i = 0; i < meses.length; i++) {
				m[meses[i].mes] = {importe: meses[i].real}
			}

			this.verDetalles(cliente, m, tipo)
		}
	}
}
</script>

<style scoped>
td.importe:hover {
	cursor: pointer;
}

td.importe:hover {
	background-color: darkred;
	color: white;
}
</style>


// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porClientes/tablaIntervalo.vue